// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"249":"7460ba6a","4708":"6fa76568","5506":"4cb0cf48","5756":"03c41866"}[chunkId] + ".chunk.css";
};